import React, { Component } from 'react';

import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';

import Summary from '../components/Summary';
import ContractsContainer from '../containers/ContractsContainer';
import { Col, Row } from 'react-bootstrap';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import SaveStepButton from './SaveStepButton';

class CheckOut extends Component {

    render() {
        let summary = (<Col xs={12} md={8} lg={5}><Summary /></Col>);

        if (['ftyc', 'fiduciaria', 'cuyoaval', 'cuyoavalcheque'].includes(process.env.PAGE)){
            summary = (
                <div className="pd-content-left col-md-5 col-lg-5 text-center">
                    <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                    <FormattedHTMLMessage id="app.step_checkout" description="Checkout info"/>
                    <div className="show-desktop">
                        <SaveStepButton/>
                    </div>
                </div>
            );
        }

        return (
            <Section className="intro_form">
                <div className="pvc-form">
                    <Row>
                        {summary}
                        <Col xs={12} md={4} lg={7}>
                            <Row>
                                <Col xs={12} md={4} lg={1}>
                                </Col>
                                <Col xs={12} md={4} lg={11}>
                                    <ContractsContainer/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <div className="show-mobile">
                    <SaveStepButton/>
                </div>
            </Section>
        );
    }
}


CheckOut.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

CheckOut = TopScrolleable(CheckOut);
CheckOut = withAuthControl(CheckOut);
export default CheckOut;



/** WEBPACK FOOTER **
 ** ./src/components/CheckOut.js
 **/